<template>
    <div class="formulario-pessoa">
        <h4 class="header2">Dados pessoais</h4>
        <div class="row">
            <div class=" col m6 s12">
                <label for="pessoa_nome" >Nome*</label>
                <input
                    v-validate="'required'" data-vv-delay="1000"
                    :class="errors.has('pessoa_nome') ? 'invalid' : '' "
                    class="validate active form-control"
                    id="pessoa_nome"
                    name="pessoa_nome"

                    type="text" v-model="formData.pessoa_nome" >

                <span class="helper-text red-light-text" data-success="right" v-if="errors.has('pessoa_nome')">Campo obrigatório</span>
            </div>
            <div class=" col m6 s12">
            <!--
            -->
                     <label for="pessoa_profissao" :class="checkValue(formData.pessoa_profissao)">Profissão*</label>
                <input
                    v-validate="'required'" data-vv-delay="1000"
                    :class="errors.has('pessoa_profissao') ? 'invalid' : '' "
                    class="validate form-control"
                    id="pessoa_profissao"
                    name="pessoa_profissao"
                    list="profissao"
                    type="text" v-model="formData.pessoa_profissao">

                <span class="helper-text red-light-text" data-success="right" v-if="errors.has('pessoa_profissao')">Campo obrigatório</span>
            </div>
        </div>
        <div class="row">
            <div class=" col m3 s12">
                <label for="pessoa_cpf" :class="checkValue(formData.pessoa_cpf)">CPF</label>
                <masked-input
                    type="tel"
                    id="pessoa_cpf"
                    name="pessoa_cpf"
                    class="form-control"
                    v-model="formData.pessoa_cpf"
                    mask="111.111.111-11"
                 />


            </div>
            <div class=" col m6 s12">
                    <label for="pessoa_email" :class="checkValue(formData.pessoa_email)">Email</label>
                <input
                    id="pessoa_email"
                    name="pessoa_email"
                    class="form-control"
                    type="email" v-model="formData.pessoa_email">
            </div>
            <div class="col m3 s12">
                <label for="pessoa_estado_civil">Estado civil</label>
                <select class="browser-default" v-model="formData.pessoa_estado_civil" id="pessoa_estado_civil">
                    <option value="" selected disabled>Selecione ...</option>
                    <option value="C">Casado</option>
                    <option value="S">Solteiro</option>
                    <option value="D">Divorciado</option>
                    <option value="V">Viúvo</option>
                    <option value="O">Outros</option>
                    <option value="SJ">Separado Judicialmente</option>
                    <option value="UE">União Estável</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col m3 s12">
                <label for="pessoa_sexo">Sexo</label>
                <select class="browser-default" v-model="formData.pessoa_sexo" id="pessoa_sexo">
                    <option value="" selected disabled>Selecione ...</option>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                </select>
            </div>
            <div class=" col m3 s12">
            <!--
                    v-validate="'required|fixo'" data-vv-delay="1000"
                    :class="errors.has('pessoa_telefone') ? 'invalid' : '' "
                    class="validate form-control"

            -->
                <label for="pessoa_telefone" :class="errors.has('pessoa_telefone')">Telefone</label>
                <masked-input
                    id="pessoa_telefone"
                    name="pessoa_telefone"
                    type="tel"
                    class="form-control"
                    v-model="formData.pessoa_telefone" mask="(11)1111-1111" />
                <!-- <span class="helper-text red-light-text" data-success="right" v-if="errors.has('pessoa_telefone')">Telefone inválido</span> -->
            </div>
            <div class=" col m3 s12">
                <label for="pessoa_celular" :class="checkValue(formData.pessoa_celular)">Celular*</label>
                <masked-input
                    v-validate="'required|celphone'" data-vv-delay="1000"
                    class="validate form-control"
                    :class="errors.has('pessoa_celular') ? 'invalid' : '' "
                    id="pessoa_celular"
                    name="pessoa_celular"
                    type="tel"
                v-model="formData.pessoa_celular" mask="(11)11111-1111"/>
                <span class="helper-text red-light-text" data-success="right" v-if="errors.has('pessoa_celular')">Celular inválido</span>
            </div>
            <div class=" col m3 s12">
                <label for="pessoa_data_nascimento" :class="checkValue(formData.pessoa_data_nascimento)">Data nascimento</label>
                <masked-input
                    v-validate="'date_format:dd/MM/yyyy|mydata'" data-vv-delay="1000"
                    :class="errors.has('pessoa_data_nascimento') ? 'invalid' : '' "
                    class="validate form-control"
                    name="pessoa_data_nascimento"
                    id="pessoa_data_nascimento"
                    type="text"
                    v-model="formData.pessoa_data_nascimento" mask="11/11/1111"/>
                <span class="helper-text red-light-text" data-success="right" v-if="errors.has('pessoa_data_nascimento')">Data incorreta</span>
            </div>
        </div>
        <div class="row" v-if="simuladorStatus == 0">
            <div class="col m3 s12">
                <label>Possui filhos</label>
                <div class="switch">
                    <label>
                        Não
                        <input v-model="flagFilhos" type="checkbox">
                        <span class="lever"></span>
                        Sim
                    </label>
                </div>
            </div>
            <div class=" col m3 s12" v-if="flagFilhos">
                <label for="pessoa_filhos" class="active">Quantos</label>
                <input id="pessoa_filhos" type="text" v-model="formData.pessoa_filhos">
            </div>
        </div>
        <div class="row mt-2">
            <div class=" col m12 s12">
                <label for="pessoa_observacao" :class="checkValue(formData.pessoa_observacao)">Observações</label>
                <textarea class="materialize-textarea p-0 form-control" v-model="formData.pessoa_observacao" id="pessoa_observacao"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, CORRETOR } from '@/constants/funcionarioCargo.js';
    import { get } from "@/helpers/api";

    export default {
        inject: ['$validator'],
        components: {
            MaskedInput
        },
        props: ['pessoa'],
        data: () => ({
            formData: {
                pessoa_nome: '',
                pessoa_cpf: '',
                pessoa_email: '',
                pessoa_sexo: '',
                pessoa_telefone: '',
                pessoa_celular: '',
                pessoa_data_nascimento: '',
                pessoa_profissao: '',
                pessoa_estado_civil: '',
                pessoa_filhos: 0,
                pessoa_observacao: ''
            },
            flagFilhos: false,
            simuladorStatus: 0,
            profissao: [
                { id: 1, nome: 'Médico' },
                { id: 2, nome: 'Enfermeiro' },
                { id: 3, nome: 'Fisioterapeuta' },
                { id: 4, nome: 'Dentista' },
                { id: 5, nome: 'Engenheiro' },
                { id: 6, nome: 'Advogado' }
            ]
        }),
        async created() {

            const {data: {result: {data: simulador}}} = await get('simulador-habilitado');

            this.simuladorStatus = simulador.status;


            if (this.pessoa) {
                this.formData.pessoa_data_nascimento = this.pessoa.pessoa_data_nascimento ? moment(this.pessoa.pessoa_data_nascimento).format('DD/MM/YYYY') : '';
                this.formData.pessoa_nome = this.pessoa.pessoa_nome;
                this.formData.pessoa_cpf = this.pessoa.pessoa_cpf;
                this.formData.pessoa_email = this.pessoa.pessoa_email;
                this.formData.pessoa_sexo = this.pessoa.pessoa_sexo;
                this.formData.pessoa_telefone = this.pessoa.pessoa_telefone;
                this.formData.pessoa_celular = this.pessoa.pessoa_celular;
                //this.formData.pessoa_data_nascimento = this.pessoa.pessoa_data_nascimento;
                this.formData.pessoa_profissao = this.pessoa.pessoa_profissao;
                this.formData.pessoa_estado_civil = this.pessoa.pessoa_estado_civil;
                this.formData.pessoa_filhos = this.pessoa.pessoa_filhos;
                this.formData.pessoa_observacao = this.pessoa.pessoa_observacao;
                if (this.pessoa.pessoa_filhos > 0) {
                    this.flagFilhos = true;
                }
            }
        },
        watch: {
            errors(){
                // console.log(1111111111, this.erros);
                // console.log(1111111111, this.erros);
            },
            formData: {
                handler: function() {
                    this.$emit('newdata', [
                        this.formData.pessoa_nome,
                        this.formData.pessoa_cpf,
                        this.formData.pessoa_email,
                        this.formData.pessoa_sexo,
                        this.formData.pessoa_telefone,
                        this.formData.pessoa_celular,
                        this.formData.pessoa_data_nascimento,
                        this.formData.pessoa_profissao,
                        this.formData.pessoa_estado_civil,
                        this.formData.pessoa_filhos,
                        this.formData.pessoa_observacao,
                    ]);

                    this.$emit('input', this.formData);
                },
                deep: true
            }
        },
        methods: {

            checkValue(value) {
                if (value !== '' && value !== '___.___.___-__') {
                    return 'active';
                }
                return '';
            }
        }
    }
</script>

<style>
.formulario-pessoa.step-parent{
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormularioPessoa.vue